import React from 'react';
import PropTypes from 'prop-types';

import SectionSubHeader from '../../generic/section-sub-header';
import DynamicStringList from '../../generic/dynamic-string-list';

const CourseAudienceSection = ({
  audienceInfoProfessional,
  audienceInfoStudent,
  onChange,
}) => (
  <section className="section-container course-audience-section">
    <SectionSubHeader
      title="Course Audience"
      description="Describe the intended audience for this course."
    />
    <DynamicStringList
      items={audienceInfoProfessional || []}
      fieldKey="audienceInfoProfessional"
      label="Professional"
      addLabel="Add Professional Audience Item"
      deleteLabel="Delete"
      placeholder="You're a professional who..."
      onChange={onChange}
    />
    <DynamicStringList
      items={audienceInfoStudent || []}
      fieldKey="audienceInfoStudent"
      label="Student"
      addLabel="Add Student Audience Item"
      deleteLabel="Delete"
      placeholder="You're a current or recent student who..."
      onChange={onChange}
    />
  </section>
);

CourseAudienceSection.defaultProps = {
  audienceInfoProfessional: [],
  audienceInfoStudent: [],
};

CourseAudienceSection.propTypes = {
  audienceInfoProfessional: PropTypes.arrayOf(PropTypes.string),
  audienceInfoStudent: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
};

export default CourseAudienceSection;
